import { render, staticRenderFns } from "./StartIncome.vue?vue&type=template&id=899c6b14&"
import script from "./StartIncome.vue?vue&type=script&lang=js&"
export * from "./StartIncome.vue?vue&type=script&lang=js&"
import style0 from "./StartIncome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports